<template>
  <div :class="range ? 'flex gap-2' : ''">
    <input
      type="date"
      :value="startValue"
      :min="minimum"
      :required="required"
      :readonly="readonly"
      class="w-full bg-transparent px-3 py-2"
      @input="updateStart($event.target.value)"
    />
    <input
      v-if="range"
      type="date"
      :value="endValue"
      :min="startValue || minimum"
      :required="required"
      :readonly="readonly"
      class="w-full bg-transparent px-3 py-2"
      @input="updateEnd($event.target.value)"
    />
  </div>
</template>

<script>
const formatDate = (value) => {
  if (!value) return "";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toISOString().slice(0, 10);
};

export default {
  name: "AppDatePicker",
  props: {
    modelValue: {
      default: null,
    },
    value: {
      default: null,
    },
    range: Boolean,
    minDate: {
      default: null,
    },
    required: Boolean,
    readonly: Boolean,
  },
  emits: ["update:modelValue", "input", "change"],
  computed: {
    selected() {
      return this.modelValue ?? this.value;
    },
    startValue() {
      return formatDate(this.range ? this.selected?.[0] : this.selected);
    },
    endValue() {
      return formatDate(this.range ? this.selected?.[1] : null);
    },
    minimum() {
      return formatDate(this.minDate);
    },
  },
  methods: {
    emitValue(value) {
      this.$emit("update:modelValue", value);
      this.$emit("input", value);
      this.$emit("change", value);
    },
    updateStart(value) {
      if (this.range) {
        this.emitValue([value, this.endValue].filter(Boolean));
      } else {
        this.emitValue(value);
      }
    },
    updateEnd(value) {
      this.emitValue([this.startValue, value].filter(Boolean));
    },
  },
};
</script>
